import React from 'react';

export default function StatusChip({ label, color }) {
  const bg = {
    yellow: 'bg-yellow-100 text-yellow-800',
    green: 'bg-green-100 text-green-800',
    red: 'bg-red-100 text-red-800',
    gray: 'bg-gray-200 text-gray-800',
  }[color] || 'bg-gray-200 text-gray-800';

  return (
    <span className={`px-3 py-1 rounded-full text-sm ${bg}`}>
      {label}
    </span>
  );
}